import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeedLayoutComponent } from '../layout/feed-layout/feed-layout.component';
import { FeedComponent } from './feed.component';
import { FeedFeatureComponent } from './feed-feature/feed-feature.component';

const routes: Routes = [
  {
    path: 'feed',
    component: FeedComponent
  },
  {
    path: 'feed-feature/:id',
    component: FeedFeatureComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeedRoutingModule { }
